// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disputely-logo-new-2-1-icon40,
.images1 {
  width: 106px;
  height: 34px;
  overflow: hidden;
}
.dashboard-1-icon,
.group-278-1 {
  object-fit: cover;
}
.dashboard-1-icon {
  top: 113px;
  left: 59px;
  border-radius: 10px;
  width: 579px;
  height: 390px;
}
.group-278-1 {
    position: absolute;
    bottom: 24px;
    left: 30%;
    width: 352px;
    z-index: 99;
    height: 190px;
}

.status58,
.status59,
.status60 {
  top: 251px;
  border-radius: 100px;
  width: 44px;
  height: 44px;
  display: flex;
  flex-direction: row;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
}
.status58 {
    background: linear-gradient(
        -71.92deg,
        rgba(0, 96, 239, 0.5),
        rgba(0, 118, 255, 0.5)
      ),
      #fff;
  }
  
  .status59 {
    background: linear-gradient(134.09deg, #4ebda9, #ace7dc);
  }
  .status60 {
    background: linear-gradient(
        -52.62deg,
        rgba(126, 105, 254, 0.5),
        rgba(35, 0, 255, 0.5)
      ),
      #fff;
    box-shadow: 0 8px 12px rgba(51, 51, 243, 0.2);
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/components/Auth.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;;;EAGE,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;IACI;;;;;UAKM;EACR;;EAEA;IACE,wDAAwD;EAC1D;EACA;IACE;;;;;UAKM;IACN,6CAA6C;EAC/C","sourcesContent":[".disputely-logo-new-2-1-icon40,\n.images1 {\n  width: 106px;\n  height: 34px;\n  overflow: hidden;\n}\n.dashboard-1-icon,\n.group-278-1 {\n  object-fit: cover;\n}\n.dashboard-1-icon {\n  top: 113px;\n  left: 59px;\n  border-radius: 10px;\n  width: 579px;\n  height: 390px;\n}\n.group-278-1 {\n    position: absolute;\n    bottom: 24px;\n    left: 30%;\n    width: 352px;\n    z-index: 99;\n    height: 190px;\n}\n\n.status58,\n.status59,\n.status60 {\n  top: 251px;\n  border-radius: 100px;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n}\n.status58 {\n    background: linear-gradient(\n        -71.92deg,\n        rgba(0, 96, 239, 0.5),\n        rgba(0, 118, 255, 0.5)\n      ),\n      #fff;\n  }\n  \n  .status59 {\n    background: linear-gradient(134.09deg, #4ebda9, #ace7dc);\n  }\n  .status60 {\n    background: linear-gradient(\n        -52.62deg,\n        rgba(126, 105, 254, 0.5),\n        rgba(35, 0, 255, 0.5)\n      ),\n      #fff;\n    box-shadow: 0 8px 12px rgba(51, 51, 243, 0.2);\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
